<template>
  <div>
    <v-card light>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="editedItem.po_box"
                label="Po Box"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="editedItem.idens"
                label="Identificador"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="editedItem.guia_hija"
                label="Guia hija"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="editedItem.cantidad_bultos"
                label="Cantidad de Bultos"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-menu
                v-model="menuDatePicker"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="editedItem.fecha_arribo"
                    label="Fecha de Arribo"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="editedItem.fecha_arribo"
                  @input="menuDatePicker = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="editedItem.nro_traking"
                label="Nro de Guia"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="editedItem.remite"
                label="Remitente"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="editedItem.peso"
                label="Peso"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-select
                v-model="editedItem.unidad_peso"
                :items="unidad_peso"
                item-text="state"
                item-value="abbr"
                label="Unidad"
              ></v-select>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closeDialog"
          >Cancelar</v-btn
        >
        <v-btn color="blue darken-1" text @click="save">Guardar</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
export default {
  name: "dialog-edit-item",
  props: ["editedItem"],
  data: function () {
    return {
      unidad_peso: [
        { state: "Kilo", abbr: "kg" },
        { state: "Libra", abbr: "lb" },
      ],
      menuDatePicker: false,
    };
  },
  computed: {
    formTitle() {
      return this.editedItem?.id ?  "Edición de Tracking" : "Nuevo Tracking";
    },
  },
  methods: {
    closeDialog() {
      this.$emit("closeDialog");
    },
    save() {
      this.$emit("saveDialog");
    }
  },
};
</script>
<style lang="">
</style>